import React, { useEffect, useState } from 'react';
import { Divider, Dropdown, Grid } from 'semantic-ui-react';

import { FieldLabel } from '../../styles';

import { ReportsPageWrapper, SelectWrapper, Subtitle, Title } from './styles';
import RealEstateReport from './components/RealEstateReport';
import FireInsuranceBillingDataReport from './components/FireInsuranceBillingDataReport';
import { DocumentTypeOption, DocumentTypes } from './types';
import CommissionReport from './components/CommissionReport';
import FireInsuranceInvoiceDataReport from './components/FireInsuranceInvoiceDataReport';
import CapitalizationReport from './components/CapitalizationReport';
import { get } from '../../services/storage';
import { UserRolesEnum } from '../../enums/user-roles.enum';
import GeneralProductionReport from './components/GeneralProductionReport';
import FranchiseReport from './components/FranchiseReport';

const documentTypeOptions: DocumentTypeOption[] = [
  {
    key: 'Relatório de imobiliárias',
    text: 'Relatório de imobiliárias',
    value: 'REAL_ESTATE'
  },
  {
    key: 'Relatório de Dados do faturamento',
    text: 'Relatório de Dados do faturamento',
    value: 'BILLING_DATA'
  },
  {
    key: 'Relatório de Comissionamento',
    text: 'Relatório de Comissionamento',
    value: 'COMMISSIONING'
  },
  {
    key: 'Relatório de Faturas de Seguro incêndio',
    text: 'Relatório de Faturas de Seguro incêndio',
    value: 'FIRE_INSURANCE_INVOICES'
  },
  {
    key: 'Relatório de Capitalização',
    text: 'Relatório de Capitalização',
    value: 'CAPITALIZATION'
  },
  {
    key: 'Relatório de Produção Geral',
    text: 'Relatório de Produção Geral',
    value: 'GENERAL_PRODUCTION'
  },
  {
    key: 'Relatório de Franqueados',
    text: 'Relatório de Franqueados',
    value: 'FRANCHISE'
  }
];

const Reports: React.FC = () => {
  const [documentType, setDocumentType] = useState<DocumentTypes | null>(null);

  const userRole = get('role');

  const options =
    userRole === UserRolesEnum.estateAdmin || userRole === UserRolesEnum.estateUser
      ? documentTypeOptions.filter(option => option.value === 'GENERAL_PRODUCTION')
      : documentTypeOptions;

  useEffect(() => {
    if (userRole === UserRolesEnum.estateAdmin || userRole === UserRolesEnum.estateUser) {
      setDocumentType('GENERAL_PRODUCTION');
    }
  }, [userRole]);

  return (
    <ReportsPageWrapper>
      <Title>Exportar relatório</Title>

      <Subtitle>
        Selecione o tipo de documento e configurações para exportá-lo. O relatório
        selecionado será baixado em seguida em formato de planilha (Excel).
      </Subtitle>

      <Divider />

      <Grid.Column width={8}>
        <FieldLabel paddingTop paddingBottom>
          Tipo de documento*
        </FieldLabel>

        <SelectWrapper>
          <Dropdown
            id="documentType"
            name="documentType"
            options={options}
            placeholder="Selecionar tipo de documento"
            onChange={(_, data) => setDocumentType(data.value as DocumentTypes)}
            clearable
            selection
          />
        </SelectWrapper>
      </Grid.Column>

      {documentType === 'BILLING_DATA' && (
        <FireInsuranceBillingDataReport closeSection={() => setDocumentType(null)} />
      )}

      {documentType === 'COMMISSIONING' && (
        <CommissionReport closeSection={() => setDocumentType(null)} />
      )}

      {documentType === 'REAL_ESTATE' && (
        <RealEstateReport closeSection={() => setDocumentType(null)} />
      )}

      {documentType === 'FIRE_INSURANCE_INVOICES' && (
        <FireInsuranceInvoiceDataReport closeSection={() => setDocumentType(null)} />
      )}

      {documentType === 'CAPITALIZATION' && (
        <CapitalizationReport closeSection={() => setDocumentType(null)} />
      )}

      {documentType === 'GENERAL_PRODUCTION' && (
        <GeneralProductionReport
          closeSection={() => setDocumentType(null)}
          role={userRole || ''}
        />
      )}

      {documentType === 'FRANCHISE' && (
        <FranchiseReport
          closeSection={() => setDocumentType(null)}
          role={userRole || ''}
        />
      )}
    </ReportsPageWrapper>
  );
};

export default Reports;
